import 'UI/Widget/Forms/ViewForm';
import 'Cadastre/Data/Cadnums';
/** @namespace Accounting.UI */
NS('Cadastre.UI');

/**
 * @class
 * @extends Accounting.UI.ObjectForm
 * @extends UI.Widget.Forms.Render.Light
 */
Cadastre.UI.Cadnum = Class(
	UI.Widget.Forms.ViewForm, {
		formTemplate: "UI/Widget/Forms/ViewForm/ViewForm",
		showCloseBtn: false,

		css: {
			'box-shadow': 'none',
			'border-radius': 0,
			'border-right': '1px #DCE3EB solid',
			'border-left': '1px #DCE3EB solid',
			'border-bottom': '1px #DCE3EB solid',

		},

		//columns: Util.create('Cadastre.Data.Cadnums').fields
		columns: [
			{ name: "cadnum", title: "Кадастровый номер" }, // streing

			{ name: "datecreate", title: "Дата создания" },
			{ name: "dateins", title: "Дата добавления" },
			{ name: "datechange", title: "Дата изменения" },
			{ name: "type.name", title: "Тип" },
			{ name: "state.name", title: "Статус" },
			{ name: "category.name", title: "Категория" },
			{ name: "permitteduse", title: "Разр. использование по док." },
			{ name: "permitteduserr.name", title: "Разр. испол по спр. Росреестра" },
			{ name: "permitteduseme.name", title: "Разр. испол по спр. Минэконом" },
			{ name: "dateregistre", title: "Дата постановки на учет" },
			{ name: "shapeleng", title: "Протяженность границы" },
			{ name: "shapearea", title: "Прощать участка" },
			{ name: "docarea", title: "Площадь" },
			{ name: "cadastreprice", title: "Кадастровая стоимость" },
			{ name: "docaddress", title: "Адрес по документу" }
		],
	}
);